// import { VIcon, VTextarea } from "vuetify/lib";
import VForm from "@/vuetify_custom/v-form";
import VModal from "@/vuetify_custom/v-modal_v1";
// import { getsafe, formattingNumber } from "@/libs/util";
export default {
  props: {
    
  },
  data() {
    return {
      params: {
        id: null,
        del_reason: null,
      },
      show: false,
      loading: false,
    };
  },
  computed: {
    fields() {
      return [
        {
          label: "原因",
          key: "del_reason",
          type: "textareas_field",
          required: true,
          rules: [(v) => !!v || "必选"],
        },
      ];
    },
  },
  methods: {
    edit(id) {
      this.params.id = id;
      this.params.del_reason = null;
      this.show = true;
    },
    submit() {
      if (this.$refs.form.validate()) {
        this.loading = true;
        console.log(this.params)
        this.loading = false;
        this.$emit("finish", this.params)
        this.show = false;
      }
    },
  },
  render() {
    return (
      <div>
        
        <VModal
          v-model={this.show}
          dynamicHeight
          heightRate={0.5}
          title="废弃预算申请单"
          loading={this.loading}
          width={500}
          ref="modal"
          ok-text="确定"
          on={{
            ok: () => {
              this.submit();
            },
          }}
        >
          <VForm ref="form" fields={this.fields} v-model={this.params} />
        </VModal>
      </div>
    );
  },
};
